var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',_vm._g({},_vm.$listeners),[_c('span',{domProps:{"innerHTML":_vm._s(_vm.itemTitle)}}),_c('HeadArrowUpIcon',{staticClass:"link-arrow"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }